import React from 'react'
import { useSelector } from 'react-redux'

const DeleteButton = ({ title, onClick }) => {
    const darkMode = useSelector(state => state.theme.darkMode);

    return darkMode
        ?
        <a className='btn btn-sm btn-danger mr-2' onClick={onClick} style={{ cursor: 'pointer', color: '#fff', display: 'inline-block' }}>
            <i className="fas fa-trash" />
            <span style={{ marginLeft: 10 }}>{title}</span>
        </a>
        :
        <a
            className='mr-2'
            onClick={onClick} style={{
                cursor: "pointer",
                color: "maroon",
                display: "inline-block",
            }}
        >
            <i className="fas fa-trash" />
            <span style={{ marginLeft: 10 }}>{title}</span>
        </a>
}

export default DeleteButton;